export default {
  relationships: [
    { id: 'authorized_signer', name: 'Authorized Signer' },
    { id: 'ceo', name: 'CEO' },
    { id: 'cfo', name: 'CFO' },
    { id: 'manager', name: 'Manager' },
    { id: 'managing_member', name: 'Managing Member' },
    { id: 'member', name: 'Member' },
    { id: 'partner', name: 'Partner' },
    { id: 'president', name: 'President' },
    { id: 'treasurer', name: 'Treasurer' },
    { id: 'transaction_coordinator', name: 'Transaction Coordinator' },
    { id: 'other', name: 'Other' },
  ],
};



// WEBPACK FOOTER //
// ./src/components/settings/tabs/team_members/resources/relationship_types.js